<template>
  <section class="content">
    <admin-header
      :title="'Job'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
      disableQuickSearch
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminJob',
    data () {
      return {
        newEntityScreen: 'Admin - Jobs',
        searchEntityScreen: 'Admin - Job search',
        filterEventName: 'admin-job-filter',
        filterName: 'JobFilter',
        entityName: 'job'
      }
    },
    methods: {
      goToNewEntityScreen () {
        this.$router.push({ name: 'Add a new Quote' })
      },
      search (obj) {
        this.$router.push({ name: 'Admin - Job search', query: { [btoa('quick-search')]: btoa(obj.search) } })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminJob.vue?ace89400